module.exports = __webpack_public_path__ + "static/media/04_3.83c3f806.png";